var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2ZM16.88 14.33C16.88 14.42 16.86 14.51 16.83 14.6C16.76 14.77 16.62 14.91 16.45 14.98C16.36 15.02 16.27 15.03 16.18 15.03H14.32C13.93 15.03 13.62 14.72 13.62 14.33C13.62 13.94 13.93 13.63 14.32 13.63H14.5L12.39 11.52L11.37 13.04C11.25 13.21 11.07 13.33 10.86 13.35C10.65 13.37 10.45 13.3 10.3 13.15L7.32 10.17C7.05 9.9 7.05 9.46 7.32 9.18C7.59 8.9 8.03 8.91 8.31 9.18L10.69 11.56L11.71 10.04C11.83 9.87 12.01 9.75 12.22 9.73C12.44 9.71 12.63 9.78 12.78 9.93L15.5 12.65V12.47C15.5 12.08 15.81 11.77 16.2 11.77C16.59 11.77 16.9 12.08 16.9 12.47V14.33H16.88Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendDown);
export default __webpack_public_path__ + "static/media/trend-down.81dc7f3e6c5d0fbf17d29e3be455dccd.svg";
export { ForwardRef as ReactComponent };